import { TranslationSet } from './en';

// TODO: translate values from English
export const de: TranslationSet = {
  '(From Now)': '(Von jetzt an)',
  '(From Scheduled)': '(Von geplant)',
  '{amount} Off. Expires: {expires}.': '{amount} Aus. Läuft ab: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Ein detaillierter Bericht, der jede Aktivität und die Zeit, die ein Techniker oder Mitarbeiter zwischen und an jedem Standort benötigt hat, sowie die Gesamtzeit am Standort zeigt.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Ein Servicetyp mit aktivierter Inspektion wird in der Liste „Zu prüfen“ auf Mobilgeräten angezeigt. Es wird auch in der Berichterstattung verwendet.',
  'Accept Invite': 'Einladung annehmen',
  'Add Condition': 'Bedingung hinzufügen',
  'Add deficiencies to the equipment type': 'Fügen Sie dem Gerätetyp Mängel hinzu',
  'Add Deficiency': 'Mangel hinzufügen',
  'Add Equipment Field': 'Ausrüstungsfeld hinzufügen',
  'Add Equipment Type': 'Gerätetyp hinzufügen',
  'Add Equipment': 'Ausrüstung hinzufügen',
  'Add Floor Plan': 'Grundriss hinzufügen',
  'Add history by clicking the plus in the top right or by performing a service.': 'Fügen Sie den Verlauf hinzu, indem Sie oben rechts auf das Pluszeichen klicken oder einen Dienst ausführen.',
  'Add History': 'Verlauf hinzufügen',
  'Add Model Field': 'Modellfeld hinzufügen',
  'Add Model': 'Modell hinzufügen',
  'Add Option': 'Option hinzufügen',
  'Add Question': 'Frage hinzufügen',
  'Add questions using the plus icon in the top right': 'Fügen Sie Fragen über das Plus-Symbol oben rechts hinzu',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Fügen Sie Servicemonatskategorien unter Einstellungen > Servicemonatskategorien hinzu. Mit Servicemonaten können Sie für jeden Standort unterschiedliche Gerätetypen in ausgewählten Monaten aufbewahren. Beispiel: Alarme im Mai und Oktober und Feuerlöscher im Dezember.',
  'Add Service Month Category': 'Kategorie „Dienstmonat“ hinzufügen',
  'Add Service Type': 'Diensttyp hinzufügen',
  'Add service types in the settings': 'Fügen Sie in den Einstellungen Diensttypen hinzu',
  'Add service types using the plus icon in the top right': 'Fügen Sie Servicetypen über das Plus-Symbol oben rechts hinzu',
  'Add services to the equipment type': 'Fügen Sie dem Gerätetyp Dienste hinzu',
  'Add site Field': 'Site-Feld hinzufügen',
  'Add Site Override': 'Site-Überschreibung hinzufügen',
  'Add Site Type': 'Site-Typ hinzufügen',
  'Add Site': 'Site hinzufügen',
  'Add Sites': 'Websites hinzufügen',
  'Add User': 'Benutzer hinzufügen',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Fügen Sie Ihre eigenen Felder unter Einstellungen > Benutzerdefinierte Felder > Site-Felder hinzu',
  'Add': 'Hinzufügen',
  'Adding': 'Hinzufügen',
  'Address': 'Adresse',
  'Advance from Now': 'Fortschritt von jetzt an',
  'Advance from Scheduled': 'Vorzeitiger Termin als geplant',
  'Agree': 'Stimme zu',
  'All Sites Scheduled!': 'Alle Standorte geplant!',
  'All': 'Alle',
  'Already have an account? Login': 'Sie haben bereits ein Konto? Anmelden',
  'An error happened while syncing': 'Beim Synchronisieren ist ein Fehler aufgetreten',
  'April': 'April',
  'August': 'August',
  'Back': 'Zurück',
  'Billing Portal': 'Abrechnungsportal',
  'Building Reports': 'Bauberichte',
  'Cancel Plan': 'Plan kündigen',
  'Cancel Subscription': 'Abonnement kündigen',
  'Cancel': 'Abbrechen',
  'Change Model Fields': 'Modellfelder ändern',
  'Change Password': 'Passwort ändern',
  'Checklist Information': 'Informationen zur Checkliste',
  'Checklist Question': 'Frage zur Checkliste',
  'Checklist': 'Checkliste',
  'Choose File': 'Wählen Sie Datei',
  'City': 'Stadt',
  'Clear All Data': 'Alle Daten löschen',
  'Clear': 'Klar',
  'Click or tap to add location': 'Klicken oder tippen Sie, um einen Standort hinzuzufügen',
  'Close': 'Schließen',
  'Company-Wide Reports': 'Unternehmensweite Berichte',
  'Conditions': 'Bedingungen',
  'Contact': 'Kontakt',
  'Copy Barcode': 'Barcode kopieren',
  'Could not access': 'Konnte nicht zugreifen',
  'Could not find equipment with the scanned barcode': 'Mit dem gescannten Barcode konnte kein Gerät gefunden werden',
  'Could Not Service': 'Konnte nicht gewartet werden',
  'Create': 'Erstellen',
  'Creating Your Account': 'Erstellen Sie Ihr Konto',
  'Credentials are not valid': 'Anmeldeinformationen sind ungültig',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'Benutzerdefinierte Ausrüstungsfelder',
  'Custom Fields': 'Benutzerdefinierte Felder',
  'Custom Model Fields': 'Benutzerdefinierte Modellfelder',
  'Custom site Fields': 'Benutzerdefinierte Site-Felder',
  'Date': 'Datum',
  'Debug': 'Debuggen',
  'December': 'Dezember',
  'Deficiencies': 'Mängel',
  'Deficiency Report': 'Mängelbericht',
  'Deficiency': 'Mangel',
  'Delete Equipment Field?': 'Gerätefeld löschen?',
  'Delete Equipment Type?': 'Gerätetyp löschen?',
  'Delete Equipment Type': 'Gerätetyp löschen',
  'Delete Equipment?': 'Ausrüstung löschen?',
  'Delete Equipment': 'Ausrüstung löschen',
  'Delete Floor Plan?': 'Grundriss löschen?',
  'Delete Model Field?': 'Modellfeld löschen?',
  'Delete Model?': 'Modell löschen?',
  'Delete Model': 'Modell löschen',
  'Delete Override': 'Überschreibung löschen',
  'Delete Question?': 'Frage löschen?',
  'Delete Question': 'Frage löschen',
  'Delete Record?': 'Datensatz löschen?',
  'Delete Service Month?': 'Servicemonat löschen?',
  'Delete Service Type?': 'Servicetyp löschen?',
  'Delete Site Field?': 'Site-Feld löschen?',
  'Delete Site Type?': 'Site-Typ löschen?',
  'Delete Site?': 'Site löschen?',
  'Delete Site': 'Site löschen',
  'Delete User?': 'Benutzer löschen?',
  'Delete User': 'Benutzer löschen',
  'Delete': 'Löschen',
  'Deleted Equipment Field': 'Gerätefeld gelöscht',
  'Deleted Equipment': 'Gelöschte Ausrüstung',
  'Deleted Floor Plan': 'Grundriss gelöscht',
  'Deleted Model Field': 'Modellfeld gelöscht',
  'Deleted Record': 'Gelöschter Datensatz',
  'Deleted Service Month': 'Servicemonat gelöscht',
  'Deleted Service Type': 'Gelöschter Diensttyp',
  'Deleted Site Field': 'Gelöschtes Site-Feld',
  'Deleted Site Type': 'Gelöschter Site-Typ',
  'Detailed': 'Ausführlich',
  'Did not want done': 'Wollte nicht gemacht werden',
  'Done by others': 'Von anderen gemacht',
  'Don\'t have an account? Sign Up': 'Sie haben noch kein Konto? Melden Sie sich an',
  'Done': 'Fertig',
  'Edit Dates': 'Daten bearbeiten',
  'Edit Equipment': 'Ausrüstung bearbeiten',
  'Edit': 'Bearbeiten',
  'Email is not valid': 'E-Mail ist ungültig',
  'End Date': 'Enddatum',
  'Enter your email address': 'Geben Sie Ihre E-Mail-Adresse ein',
  'Equipment already has this barcode': 'Das Gerät verfügt bereits über diesen Barcode',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'Die Ausrüstung kann alles sein, vom Feuerlöscher bis zum Laufband. Richten Sie Gerätetypen unter Einstellungen > Gerätetypen ein',
  'Equipment Deleted': 'Ausrüstung gelöscht',
  'Equipment Due Consolidated Report': 'Konsolidierter Bericht über fällige Ausrüstung',
  'Equipment Due Report': 'Bericht über fällige Ausrüstung',
  'Equipment Field Information': 'Informationen zum Ausrüstungsfeld',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'Mithilfe von Gerätefeldern können Sie verschiedene zusätzliche Felder zum Gerätetyp hinzufügen, z. B. „Spannung“ oder „Km“.',
  'Equipment Fields': 'Ausrüstungsfelder',
  'Equipment for a site with all scheduled services.': 'Ausrüstung für einen Standort mit allen geplanten Dienstleistungen.',
  'Equipment Options': 'Ausstattungsoptionen',
  'Equipment Report': 'Ausrüstungsbericht',
  'Equipment Service Report': 'Geräteservicebericht',
  'Equipment SKU': 'Ausrüstungs-SKU',
  'Equipment Type Deleted': 'Gerätetyp gelöscht',
  'Equipment Type': 'Gerätetyp',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'Gerätetypen fügen Geräten schnell Inspektions- und Servicedefinitionen hinzu, wenn ein Modell ausgewählt wird, das sie enthält. Beispiele: Feuerlöscher, Laufband, LKW',
  'Equipment Types': 'Gerätetypen',
  'Equipment': 'Ausrüstung',
  'Export Billing Data': 'Abrechnungsdaten exportieren',
  'Export Data': 'Daten exportieren',
  'Export': 'Exportieren',
  'Failed to load organization.': 'Die Organisation konnte nicht geladen werden.',
  'Failed to save the organization.': 'Die Organisation konnte nicht gespeichert werden.',
  'February': 'Februar',
  'Fill out the options below to prepare your report.': 'Füllen Sie die folgenden Optionen aus, um Ihren Bericht vorzubereiten.',
  'Filter By': 'Filtern nach',
  'FlameTask Basic Subscription': 'FlameTask-Basisabonnement',
  'FlameTask Enterprise Subscription': 'FlameTask Enterprise-Abonnement',
  'FlameTask Pro Subscription': 'FlameTask Pro-Abonnement',
  'Floor Plan Location': 'Lage des Grundrisses',
  'Floor Plan': 'Grundriss',
  'Floor Plans': 'Grundrisse',
  'Force Error': 'Fehler erzwingen',
  'Forgot Password': 'Passwort vergessen',
  'Generate': 'Generieren',
  'Hide "added" history records': '„Hinzugefügte“ Verlaufseinträge ausblenden',
  'Hide Advanced': 'Erweitert ausblenden',
  'History': 'Geschichte',
  'How long a user spent at a site with time between actions.': 'Wie lange ein Benutzer auf einer Website verbracht hat, mit Zeitintervallen zwischen den Aktionen.',
  'If this email matched an account, a link was sent to reset your password.': 'Wenn diese E-Mail mit einem Konto übereinstimmt, wurde ein Link zum Zurücksetzen Ihres Passworts gesendet.',
  'Import Data': 'Daten importieren',
  'Import': 'Importieren',
  'Inspection Due': 'Inspektion fällig',
  'Inspection Report': 'Inspektionsbericht',
  'Inspection': 'Inspektion',
  'Inspections are up to date': 'Die Inspektionen sind auf dem neuesten Stand',
  'January': 'Januar',
  'July': 'Juli',
  'June': 'Juni',
  'Leave': 'Geh',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Liste aller Geräte am Standort mit Optionen zur Anzeige von Diensten und Filterung nach fälliger Wartung und/oder Inspektion.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Liste aller Seiten mit ihren Informationen. Optionen zum Filtern nach Status und Servicemonat, um herauszufinden, welche Websites in einem bestimmten Monat gewartet werden.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Liste der Geräte und Mängel am Standort, gefiltert nach Geräten mit Mängeln, die ein Eröffnungsdatum und kein Schließungsdatum haben.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Liste der Geräte aus einem bestimmten Zeitraum mit Antworten auf die Fragen, die bei der Durchführung einer Wartung oder Inspektion gestellt werden.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Liste der Geräte für einen Standort mit wichtigen Informationen wie dem Datum der letzten Inspektion und dem nächsten fälligen Service, wobei die Geräte, die zur Inspektion anstehen, rot hervorgehoben sind.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Liste der Geräte, die den Modellsuchkriterien entsprechen. Beispiel: eine Liste von 5 Ausrüstungsgegenständen mit Modellinformationen, die zu 6LB ABC DRY passen.',
  'Loading Equipment': 'Ladeausrüstung',
  'Loading Models...': 'Modelle werden geladen...',
  'Loading Scheduled Services...': 'Geplante Dienste werden geladen...',
  'Loading Scheduled Sites': 'Laden geplanter Sites',
  'Loading Service Types...': 'Servicetypen werden geladen...',
  'Loading Sites': 'Laden von Websites',
  'Loading Unscheduled Services...': 'Außerplanmäßige Dienste werden geladen...',
  'Loading...': 'Laden...',
  'Location': 'Standort',
  'Logging in...': 'Anmelden...',
  'Login Failed': 'Anmeldung fehlgeschlagen',
  'Login': 'Anmelden',
  'Logout': 'Abmelden',
  'March': 'März',
  'May': 'Mai',
  'Meter Based Condition': 'Zählerbasierter Zustand',
  'Model Deleted': 'Modell gelöscht',
  'Model Field Information': 'Modellfeldinformationen',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'Mit Modellfeldern können Sie Geräte wie „Größe“, „Typ“ und „Kategorie“ beschreiben und darüber berichten.',
  'Model Fields': 'Modellfelder',
  'Model Information': 'Modellinformationen',
  'Model Name': 'Modellname',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'Modelle ermöglichen das schnelle Hinzufügen von Informationen zu Geräten, z. B. zu welchem Gerätetyp/welchen Diensten sie gehören.',
  'Models': 'Modelle',
  'Months of History (to start of month)': 'Monate der Geschichte (bis Monatsanfang)',
  'More Details': 'Weitere Details',
  'Name': 'Name',
  'Nevermind': 'Egal',
  'No Custom Equipment Fields': 'Keine benutzerdefinierten Ausrüstungsfelder',
  'No Deficiencies': 'Keine Mängel',
  'No Equipment Fields': 'Keine Ausrüstungsfelder',
  'No Equipment Types': 'Keine Gerätetypen',
  'No Equipment': 'Keine Ausrüstung',
  'No Floor Plans': 'Keine Grundrisse',
  'No History': 'Keine Geschichte',
  'No Model Fields': 'Keine Modellfelder',
  'No Models': 'Keine Modelle',
  'No Open Deficiencies': 'Keine offenen Mängel',
  'No Open or Closed Issues': 'Keine offenen oder geschlossenen Probleme',
  'No overrides for this Site': 'Keine Überschreibungen für diese Site',
  'No Questions': 'Keine Fragen',
  'No Scheduled Services': 'Keine geplanten Dienste',
  'No Scheduled Sites': 'Keine geplanten Websites',
  'No Service Month Categories': 'Keine Servicemonatskategorien',
  'No Service Types': 'Keine Servicetypen',
  'No Site Fields': 'Keine Site-Felder',
  'No Site Types': 'Keine Site-Typen',
  'No Sites': 'Keine Websites',
  'No Unscheduled Services': 'Keine außerplanmäßigen Dienste',
  'No, Go Back': 'Nein, geh zurück',
  'No': 'Nein',
  'Not in at the time of inspection': 'Zum Zeitpunkt der Inspektion nicht da',
  'Nothing to Inspect': 'Nichts zu prüfen',
  'Nothing to Service': 'Nichts zu warten',
  'November': 'November',
  'October': 'Oktober',
  'Ok': 'Ok',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Öffnen Sie einen Mangel, indem Sie oben rechts im Bereich auf das Pluszeichen klicken. Wenn das Problem behoben ist, klicken Sie darauf und legen Sie das Schließdatum fest.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Öffnen Sie einen Mangel, indem Sie auf Optionen > Mangel hinzufügen tippen',
  'Open Deficiencies': 'Offene Mängel',
  'Open Deficiency': 'Offener Mangel',
  'Open in Apple Maps': 'In Apple Maps öffnen',
  'Open in Google Maps': 'In Google Maps öffnen',
  'Open Settings': 'Öffnen Sie Einstellungen',
  'Open': 'Offen',
  'Optional: Add a deficiency if this option is selected.': 'Optional: Fügen Sie einen Mangel hinzu, wenn diese Option ausgewählt ist.',
  'Optional: This can be useful to set meter values easily': 'Optional: Dies kann nützlich sein, um Zählerwerte einfach einzustellen',
  'Organization': 'Organisation',
  'Outstanding Equipment': 'Hervorragende Ausrüstung',
  'PDF': 'PDF',
  'Perform From Now': 'Führen Sie ab sofort durch',
  'Perform From Scheduled': 'Von geplant ausführen',
  'Perform Service From Scheduled': 'Führen Sie den Service nach Plan durch',
  'Perform Service': 'Service durchführen',
  'Perform': 'Führen Sie durch',
  'Phone Number': 'Telefonnummer',
  'Please fill out all fields': 'Bitte füllen Sie alle Felder aus',
  'Please give a reason': 'Bitte geben Sie einen Grund an',
  'Please select country first': 'Bitte wählen Sie zuerst das Land aus',
  'Popup Note': 'Popup-Hinweis',
  'Preferences': 'Präferenzen',
  'Preview Details': 'Vorschaudetails',
  'Profile': 'Profil',
  'Purchase Barcodes': 'Kaufen Sie Barcodes',
  'Question Deleted': 'Frage gelöscht',
  'Question Information': 'Frageninformationen',
  'Questionnaire Report': 'Fragebogenbericht',
  'Questions': 'Fragen',
  'Range End': 'Bereichsende',
  'Range Start': 'Bereichsanfang',
  'Reactivate': 'Reaktivieren',
  'Remove': 'Entfernen',
  'Replace Barcode': 'Barcode ersetzen',
  'Replace Equipment': 'Ersetzen Sie die Ausrüstung',
  'Replaced equipment': 'Ersetzte Ausrüstung',
  'Report Date': 'Berichtsdatum',
  'Reports': 'Berichte',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Sparen Sie Zeit und minimieren Sie Risiken, indem Sie den Standort der Geräte auf einem Grundriss dieses Standorts eintragen',
  'Save': 'Speichern',
  'Saving': 'Sparen',
  'Scan barcode to make changes': 'Scannen Sie den Barcode, um Änderungen vorzunehmen',
  'Scan Barcode': 'Barcode scannen',
  'Scan': 'Scannen',
  'Schedule': 'Zeitplan',
  'Scheduled Event': 'Geplante Veranstaltung',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'Geplante Servicedefinitionen können dem Gerätetyp unter Einstellungen > Gerätetypen hinzugefügt werden',
  'Scheduled': 'Geplant',
  'See More': 'Mehr anzeigen',
  'Selecting an option will add a history record and remove it from the todo list': 'Durch Auswahl einer Option wird ein Verlaufseintrag hinzugefügt und aus der Aufgabenliste entfernt',
  'Selective Equipment Report': 'Selektiver Ausrüstungsbericht',
  'September': 'September',
  'Service Due': 'Service fällig',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'Mithilfe von Wartungsmonatskategorien können Sie unterschiedliche Gerätetypen in unterschiedlichen Monaten aufbewahren. Beispielsweise könnten Sie im August und Mai Feuerlöscher und im Oktober Alarmanlagen inspizieren.',
  'Service Month Categories': 'Servicemonatskategorien',
  'Service Month Category': 'Kategorie „Dienstmonat“.',
  'Service Month': 'Servicemonat',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'Mit Servicemonaten können Sie für jeden Standort unterschiedliche Gerätetypen in ausgewählten Monaten aufbewahren. Beispiel: Alarme im Mai und Oktober und Feuerlöscher im Dezember.',
  'Service Months': 'Servicemonate',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'Mit Dienstüberschreibungen können Sie einen Dienst deaktivieren oder die Häufigkeit für eine bestimmte Site ändern',
  'Service Type Settings': 'Servicetyp-Einstellungen',
  'Service Type': 'Servicetyp',
  'Service Types': 'Servicetypen',
  'Service': 'Service',
  'Services are up to date': 'Die Dienste sind auf dem neuesten Stand',
  'Services': 'Dienstleistungen',
  'Set answer to equipment field': 'Legen Sie die Antwort auf das Feld „Ausrüstung“ fest',
  'Settings': 'Einstellungen',
  'Show Advanced': 'Erweitert anzeigen',
  'Show History Time': 'Verlaufszeit anzeigen',
  'Show Inspections': 'Inspektionen anzeigen',
  'Show Questions / Answers': 'Fragen/Antworten anzeigen',
  'Show Services': 'Leistungen anzeigen',
  'Sign Up': 'Melden Sie sich an',
  'Simulate Scan': 'Scan simulieren',
  'Site Deleted': 'Website gelöscht',
  'Site Field Information': 'Informationen zum Site-Feld',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'Mithilfe von Site-Feldern können Sie zusätzliche Informationen in die Site eingeben, beispielsweise „Standort des Parkplatzes“.',
  'Site Fields': 'Site-Felder',
  'Site Information': 'Site-Informationen',
  'Site Report': 'Site-Bericht',
  'Site Reports': 'Site-Berichte',
  'Site Service Override': 'Site-Service-Überschreibung',
  'Site Service Overrides': 'Site-Service-Überschreibungen',
  'Site Service Settings': 'Site-Service-Einstellungen',
  'Site Settings': 'Site-Einstellungen',
  'Site Type': 'Site-Typ',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'Mit Site-Typen können Sie Servicetypen basierend auf der Site ändern. Beispielsweise würden nur monatliche Kunden die monatliche Inspektion vorzeigen.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'Mit Site-Typen können Sie unterschiedliche Servicetypen an verschiedenen Site-Typen nutzen. Beispielsweise müssen Sie möglicherweise an einem Standort monatliche Inspektionen durchführen und an einem anderen nur eine jährliche Inspektion.',
  'Site Types': 'Site-Typen',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'Mithilfe von Websites können Sie Geräte an Orten wie „Büro“ oder „Lager“ organisieren. Wenn Sie ein Dienstleistungsunternehmen betreiben, können Sie Ihre Kunden als Standorte hinzufügen. ',
  'Sites': 'Websites',
  'Start Date': 'Startdatum',
  'Start Trial': 'Testversion starten',
  'Status': 'Status',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Zusammenfassung der Dienste an einem Standort, getrennt nach Modellinformationen. Beispiel 5 Monatliche Inspektionen mit Modellinformationen 6LB DRY ABC.',
  'Swap Equipment': 'Ausrüstung tauschen',
  'Swapped equipment': 'Ausrüstung getauscht',
  'TEST': 'TEST',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'Der EMS-Plan ist ein vergünstigter Plan für gemeinnützige oder öffentlich finanzierte Gesundheitsdienste.  Bitte wählen Sie einen anderen Plan, wenn Sie diese Kriterien nicht erfüllen',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'Die Popup-Notiz wird verwendet, um Sie an wichtige Informationen zum Standort zu erinnern. Es erscheint beim Öffnen des Standortbildschirms.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'Es gibt keine außerplanmäßigen Standorte mit ausstehenden Inspektionen, Wartungsarbeiten oder Mängeln.',
  'There is no equipment at this site with this search criteria and due inspections': 'Auf dieser Website gibt es kein Gerät mit diesen Suchkriterien und ordnungsgemäßen Inspektionen',
  'There is no equipment at this site with this search criteria and due service': 'Auf dieser Website gibt es kein Gerät mit diesen Suchkriterien und dem entsprechenden Service',
  'This Month': 'Diesen Monat',
  'Time at Site Detailed': 'Zeit am Standort im Detail',
  'Time at Site': 'Zeit vor Ort',
  'Time Based Condition': 'Zeitbasierte Bedingung',
  'Today': 'Heute',
  'Transfer Equipment': 'Transferausrüstung',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Außerplanmäßige Servicedefinitionen können dem Gerätetyp unter Einstellungen > Gerätetypen hinzugefügt werden',
  'Unscheduled': 'Außerplanmäßig',
  'Updated barcode': 'Aktualisierter Barcode',
  'Used Equipment SKU': 'Gebrauchtgeräte-SKU',
  'Used for the billing export for new, swapped and replaced equipment.': 'Wird für den Abrechnungsexport für neue, getauschte und ersetzte Geräte verwendet.',
  'User Deleted': 'Benutzer gelöscht',
  'User Information': 'Benutzerinformationen',
  'User': 'Benutzer',
  'Users': 'Benutzer',
  'View on FloorPlan': 'Auf FloorPlan ansehen',
  'View Terms': 'Bedingungen anzeigen',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'Immer wenn Geräte ausgetauscht werden, erhöht der Abrechnungsexport die Menge unter dieser SKU.',
  'Yes, Delete Equipment Field': 'Ja, Gerätefeld löschen',
  'Yes, Delete Equipment Type': 'Ja, Gerätetyp löschen',
  'Yes, Delete Equipment': 'Ja, Ausrüstung löschen',
  'Yes, Delete Floor Plan': 'Ja, Grundriss löschen',
  'Yes, Delete Model Field': 'Ja, Modellfeld löschen',
  'Yes, Delete Model': 'Ja, Modell löschen',
  'Yes, Delete Question': 'Ja, Frage löschen',
  'Yes, Delete Record': 'Ja, Datensatz löschen',
  'Yes, Delete Service Month': 'Ja, Servicemonat löschen',
  'Yes, Delete Service Type': 'Ja, Diensttyp löschen',
  'Yes, Delete Site Field': 'Ja, Site-Feld löschen',
  'Yes, Delete Site Type': 'Ja, Site-Typ löschen',
  'Yes, Delete Site': 'Ja, Site löschen',
  'Yes, Delete User': 'Ja, Benutzer löschen',
  'Zone': 'Zone',
  'Customer': 'Kunde',
  'Site': 'Website',
  'All Sites': 'Alle Websites',
  'Loading Customers': 'Laden von Kunden',
  'No Customers': 'Keine Kunden',
  'Add Customer': 'Kunde hinzufügen',
  'Customers are groups of sites with billing information.': 'Kunden sind Gruppen von Websites mit Rechnungsinformationen.',
  'Customers': 'Kunden',
  'Customer Information': 'Kundeninformationen',
  'Delete Customer': 'Kunde löschen',
  'Yes, Delete Customer': 'Ja, Kunde löschen',
  'Delete Customer?': 'Kunde löschen?',
  'Customer Deleted': 'Kunde gelöscht',
  'Create Customer': 'Kunde anlegen',
  'Assign Existing Customer': 'Bestehenden Kunden zuordnen',
  'Edit Customer': 'Kunde bearbeiten',
  'Enter a serial number': 'Geben Sie eine Seriennummer ein',
  'Remove Customer': 'Kunde entfernen',
  'Find': 'Finden',
  'Sync Now': 'Jetzt synchronisieren',
  'Syncing...': 'Synchronisierung...',
  'Find equipment by serial number': 'Finden Sie Geräte anhand der Seriennummer',
  'Last successful upload was {formattedDate}': 'Letzter erfolgreicher Upload war {formattedDate}',
  'Up to date as of {formattedDate}': 'Aktuell ab {formattedDate}',
  'Zones are used to group locations in the location report': 'Zonen werden zum Gruppieren von Standorten im Standortbericht verwendet',

  'Account Number': 'Kontonummer',
  'Add Location Override': 'Standortüberschreibung hinzufügen',
  'Add New Model': 'Neues Modell hinzufügen',
  'Add Site Field': 'Site-Feld hinzufügen',
  'Address Line 2': 'Adresszeile 2',
  'Agree to': 'Stimme zu',
  'All conditions are true': 'Alle Bedingungen sind wahr',
  'All Permissions': 'Alle Berechtigungen',
  'Allow Text Input': 'Texteingabe zulassen',
  'An email with the reset password link below has been sent to': 'Eine E-Mail mit dem Link zum Zurücksetzen des Passworts unten wurde an gesendet',
  'An error ocurred while trying to show this page.': 'Beim Versuch, diese Seite anzuzeigen, ist ein Fehler aufgetreten.',
  'Any condition is true': 'Jede Bedingung ist wahr',
  'Background Color': 'Hintergrundfarbe',
  'Billing and customer controls': 'Abrechnung und Kundenkontrolle',
  'Building Reports - Safety Scan': 'Gebäudeberichte – Sicherheitsscan',
  'Change Another Service': 'Ändern Sie einen anderen Dienst',
  'Choose Site': 'Wählen Sie Site',
  'click here': 'klicken Sie hier',
  'Closed Date': 'Geschlossenes Datum',
  'Closed Deficiencies': 'Geschlossene Mängel',
  'Company Information': 'Unternehmensinformationen',
  'Company Name': 'Name der Firma',
  'Completing Sign Up': 'Abschluss der Anmeldung',
  'Context ID': 'Kontext-ID',
  'Could not find equipment with that barcode': 'Es konnte kein Gerät mit diesem Barcode gefunden werden',
  'Creating invite link...': 'Einladungslink wird erstellt...',
  'Current equipment failed to load': 'Die aktuelle Ausrüstung konnte nicht geladen werden',
  'Data File': 'Datendatei',
  'Data Origin': 'Datenherkunft',
  'Date affected by': 'Datum betroffen von',
  'Date Completed': 'Datum abgeschlossen',
  'Date Started': 'Datum des Beginns',
  'Delete equipment?': 'Ausrüstung löschen?',
  'Dev Environment': 'Entwicklungsumgebung',
  'Disabled For': 'Deaktiviert für',
  'Disabled For Location': 'Für den Standort deaktiviert',
  'Do not change': 'Nicht ändern',
  'Due When': 'Fällig wann',
  'Edit Deficiencies': 'Mängel bearbeiten',
  'Edit History': 'Verlauf bearbeiten',
  'Edit Location': 'Standort bearbeiten',
  'Edit Schedule': 'Zeitplan bearbeiten',
  'Edit Service': 'Dienst bearbeiten',
  'Edit Settings': 'Einstellungen bearbeiten',
  'End Time': 'Endzeit',
  'Equal to': 'Gleich',
  'Equipment Field': 'Ausrüstungsbereich',
  'Equipment replaced': 'Ausrüstung ersetzt',
  'Equipment swapped': 'Ausrüstung getauscht',
  'Example: Broken Handle': 'Beispiel: Gebrochener Griff',
  'Frequency Type': 'Frequenztyp',
  'Generate Reports': 'Berichte erstellen',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Schauen Sie sich zunächst unsere Tutorials auf YouTube an oder richten Sie Ihr Konto in den Einstellungen ein.',
  'Global Search': 'Globale Suche',
  'Greater than': 'Größer als',
  'hasn&apos;t accepted their invite yet. You can': 'hat ihre Einladung noch nicht angenommen. ',
  'Include In Reports': 'In Berichte einbeziehen',
  'landscape LetterHead': 'Briefkopf im Querformat',
  'Last Date': 'Letztes Datum',
  'Last Date Minimum Granularity': 'Minimale Granularität des letzten Datums',
  'Last Download': 'Letzter Download',
  'Last Upload': 'Letzter Upload',
  'Less than': 'Weniger als',
  'Locations can only be added on a desktop browser': 'Standorte können nur in einem Desktop-Browser hinzugefügt werden',
  'Looks like you never finished signing up': 'Es sieht so aus, als hätten Sie die Anmeldung nie abgeschlossen',
  'Metered Condition': 'Dosierter Zustand',
  'Mobile Access': 'Mobiler Zugriff',
  'Model Number': 'Modellnummer',
  'Next Date (Overide)': 'Nächstes Datum (Überschreiben)',
  'No Conditions': 'Keine Bedingungen',
  'No Options': 'Keine Optionen',
  'Not equal to': 'Nicht gleich',
  'Opened Date': 'Eröffnungsdatum',
  'Option Selected': 'Option ausgewählt',
  'Perform On Scan': 'Beim Scannen ausführen',
  'Please click the button below to start your free 3 month trial': 'Klicken Sie bitte auf die Schaltfläche unten, um Ihre kostenlose 3-monatige Testversion zu starten',
  'Please review the terms below': 'Bitte lesen Sie die nachstehenden Bedingungen',
  'Portrait LetterHead': 'Briefkopf im Hochformat',
  'Postal Code': 'Postleitzahl',
  'Powered By': 'Angetrieben von',
  'Preventive Maintenance': 'Vorbeugende Wartung',
  'Profile Image': 'Profilbild',
  'Receive marketing emails': 'Erhalten Sie Marketing-E-Mails',
  'Rivison Inc.': 'Rivison Inc.',
  'Search Sites...': 'Websites durchsuchen...',
  'Serial Number': 'Seriennummer',
  'Service is Unscheduled': 'Der Service ist außerplanmäßig',
  'Service Options': 'Serviceoptionen',
  'Service or Inspection Due': 'Wartung oder Inspektion fällig',
  'Show All': 'Alle anzeigen',
  'Show site selector in top corner': 'Site-Auswahl in der oberen Ecke anzeigen',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Anmeldung fehlgeschlagen. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'Leider ist beim Versuch, einen Einladungslink zu erstellen, ein Fehler aufgetreten. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Tut mir leid, es sieht so aus, als wären Sie offline. ',
  'Start Time': 'Startzeit',
  'Successfully updated profile': 'Profil erfolgreich aktualisiert',
  'terms and conditions': 'Geschäftsbedingungen',
  'Text Input': 'Texteingabe',
  'The date below is used to show history records only.': 'Das folgende Datum wird nur zur Anzeige von Verlaufsdatensätzen verwendet.',
  'This will just take a moment': 'Das wird nur einen Moment dauern',
  'Time Condition': 'Zeitbedingung',
  'Time Zone': 'Zeitzone',
  'to generate another invite link.': 'um einen weiteren Einladungslink zu generieren.',
  'Toggle Flashlight': 'Taschenlampe umschalten',
  'Type more characters to narrow the search further': 'Geben Sie weitere Zeichen ein, um die Suche weiter einzugrenzen',
  'Use text answer for': 'Verwenden Sie eine Textantwort für',
  'Version:': 'Version:',
  'View Deficiencies': 'Mängel anzeigen',
  'View Equipment': 'Ausrüstung anzeigen',
  'View History': 'Verlauf anzeigen',
  'View Location': 'Standort anzeigen',
  'View Schedule': 'Zeitplan anzeigen',
  'View Service': 'Service anzeigen',
  'View Settings': 'Einstellungen anzeigen',
  'We hope to see you again.': 'Wir hoffen, Sie wiederzusehen.',
  'Web Login': 'Web-Login',
  'Welcome,': 'Willkommen,',
  'White Label': 'Weißes Etikett',
  'Work Day End Time': 'Endzeit des Arbeitstages',
  'Work Day Start Time': 'Startzeit des Arbeitstages',
  'You must agree to the terms and conditions': 'Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen',
  'Your Subscription Has Been Canceled': 'Ihr Abonnement wurde gekündigt',
};
